/* ==============================
   Product Details Page
   ============================== */

.view-product-page {
  --vp-bg: #f6f7f9;
  --vp-card: #ffffff;
  --vp-text: #111827;
  --vp-muted: #6b7280;
  --vp-border: #e5e7eb;
  --vp-border-dark: #d1d5db;
  --vp-primary: #ff8c00;
  --vp-primary-hover: #e67e00;
  --vp-primary-soft: #fff7ed;
  --vp-focus: rgba(255, 140, 0, 0.16);
  --vp-danger: #dc2626;
  --vp-success: #15803d;

  width: 100%;
  min-height: 100vh;
  display: flex;
  background: var(--vp-bg);
  color: var(--vp-text);
}

.view-product-page,
.view-product-page * {
  box-sizing: border-box;
}

.view-product-content {
  flex: 1;
  min-width: 0;
}

.view-product-container {
  width: 100%;
  max-width: 1250px;
  margin: 0 auto;
  padding: 28px;
}


/* ==============================
   Header
   ============================== */

.view-product-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}

.view-product-header h1 {
  margin: 10px 0 0;
  color: var(--vp-primary);
  font-size: 26px;
  font-weight: 700;
}

.view-product-header p {
  margin: 7px 0 0;
  color: var(--vp-muted);
  font-size: 14px;
}

.view-product-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  background: transparent;
  border: 0;
  color: var(--vp-muted);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.view-product-back:hover {
  color: var(--vp-primary-hover);
}


/* ==============================
   Buttons
   ============================== */

.view-product-btn {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 9px 14px;
  background: #ffffff;
  border: 1px solid var(--vp-border-dark);
  border-radius: 9px;
  color: var(--vp-text);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    transform 0.1s ease;
}

.view-product-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  transform: translateY(-1px);
}

.view-product-btn.primary {
  background: var(--vp-primary);
  border-color: var(--vp-primary);
  color: #ffffff;
}

.view-product-btn.primary:hover {
  background: var(--vp-primary-hover);
  border-color: var(--vp-primary-hover);
}

.view-product-btn.ghost {
  background: #ffffff;
}


/* ==============================
   Card
   ============================== */

.view-product-card {
  display: grid;
  grid-template-columns: 285px minmax(0, 1fr);
  overflow: hidden;
  background: var(--vp-card);
  border: 1px solid var(--vp-border);
  border-radius: 14px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.04);
}


/* ==============================
   Sidebar
   ============================== */

.view-product-sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 20px;
  background: #fafafa;
  border-right: 1px solid var(--vp-border);
}

.view-product-image {
  position: relative;
  width: 170px;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid var(--vp-border);
  border-radius: 14px;
  color: #c4c9d1;
  font-size: 66px;
}

.view-product-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 10px;
}

.view-product-image-fallback {
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
}

.view-product-image.image-error img {
  display: none;
}

.view-product-image.image-error .view-product-image-fallback {
  display: flex;
}

.view-product-summary {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 16px;
  text-align: center;
}

.view-product-summary strong {
  color: var(--vp-text);
  font-size: 15px;
  line-height: 1.35;
}

.view-product-summary span {
  color: var(--vp-muted);
  font-size: 12px;
}


/* ==============================
   Stock
   ============================== */

.view-product-stock {
  width: 100%;
  margin-top: 18px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid var(--vp-border);
  border-radius: 10px;
  text-align: center;
}

.view-product-stock span {
  display: block;
  margin-bottom: 4px;
  color: var(--vp-muted);
  font-size: 11px;
  font-weight: 600;
}

.view-product-stock strong {
  font-size: 22px;
}

.view-product-stock-low {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

.view-product-stock-normal {
  color: #374151;
}

.view-product-stock-high {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #15803d;
}


/* ==============================
   Barcode
   ============================== */

.view-product-barcode {
  width: 100%;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid var(--vp-border);
  text-align: center;
}

.view-product-barcode-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin-bottom: 12px;
  color: #374151;
  font-size: 13px;
}

.view-product-barcode canvas {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 6px;
  background: #ffffff;
  border: 1px dashed var(--vp-border-dark);
  border-radius: 8px;
}


/* ==============================
   Details
   ============================== */

.view-product-details {
  min-width: 0;
  padding: 28px;
}

.view-product-section-header {
  margin-bottom: 16px;
}

.view-product-section-header h2 {
  margin: 0;
  color: var(--vp-text);
  font-size: 17px;
  font-weight: 700;
}

.view-product-section-header p {
  margin: 5px 0 0;
  color: var(--vp-muted);
  font-size: 12px;
}

.view-product-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.view-product-grid.three-col {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.view-product-field {
  min-width: 0;
  padding: 12px 13px;
  background: #fafafa;
  border: 1px solid var(--vp-border);
  border-radius: 9px;
  color: #374151;
  font-size: 14px;
}

.view-product-field.view-product-full {
  grid-column: 1 / -1;
}

.view-product-label {
  display: block;
  margin-bottom: 5px;
  color: var(--vp-muted);
  font-size: 11px;
  font-weight: 600;
}

.view-product-code {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Monaco,
    Consolas,
    "Liberation Mono",
    "Courier New",
    monospace;
  font-size: 13px;
}

.view-product-description {
  display: block;
  white-space: pre-wrap;
  line-height: 1.55;
}


/* ==============================
   Stats
   ============================== */

.view-product-stat {
  min-width: 0;
  padding: 14px;
  background: #fafafa;
  border: 1px solid var(--vp-border);
  border-radius: 9px;
}

.view-product-stat span {
  display: block;
  margin-bottom: 5px;
  color: var(--vp-muted);
  font-size: 11px;
  font-weight: 600;
}

.view-product-stat strong {
  color: var(--vp-text);
  font-size: 16px;
}


/* ==============================
   Divider / Actions
   ============================== */

.view-product-divider {
  height: 1px;
  margin: 26px 0;
  background: var(--vp-border);
}

.view-product-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid var(--vp-border);
}


/* ==============================
   Loading / Not Found
   ============================== */

.view-product-state {
  min-height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: #ffffff;
  border: 1px solid var(--vp-border);
  border-radius: 14px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.04);
  color: var(--vp-muted);
  text-align: center;
}

.view-product-state-icon {
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  background: var(--vp-primary-soft);
  border-radius: 50%;
  color: var(--vp-primary);
  font-size: 28px;
}

.view-product-state strong {
  color: var(--vp-text);
  font-size: 16px;
}

.view-product-state span {
  max-width: 380px;
  margin: 6px 0 18px;
  font-size: 13px;
  line-height: 1.5;
}


/* ==============================
   Tablet
   ============================== */

@media (max-width: 950px) {
  .view-product-container {
    padding: 20px;
  }

  .view-product-card {
    grid-template-columns: 230px minmax(0, 1fr);
  }

  .view-product-sidebar {
    padding: 24px 16px;
  }

  .view-product-image {
    width: 130px;
    height: 130px;
  }

  .view-product-grid.three-col {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}


/* ==============================
   Mobile
   ============================== */

@media (max-width: 700px) {
  .view-product-container {
    padding: 14px;
  }

  .view-product-header {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }

  .view-product-header h1 {
    font-size: 22px;
  }

  .view-product-header .view-product-btn {
    width: 100%;
  }

  .view-product-card {
    grid-template-columns: 1fr;
  }

  .view-product-sidebar {
    border-right: 0;
    border-bottom: 1px solid var(--vp-border);
  }

  .view-product-details {
    padding: 18px;
  }

  .view-product-grid,
  .view-product-grid.three-col {
    grid-template-columns: 1fr;
  }

  .view-product-field.view-product-full {
    grid-column: auto;
  }

  .view-product-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .view-product-actions .view-product-btn {
    width: 100%;
  }
}


/* ==============================
   Small Mobile
   ============================== */

@media (max-width: 420px) {
  .view-product-container {
    padding: 10px;
  }

  .view-product-header h1 {
    font-size: 20px;
  }

  .view-product-card,
  .view-product-state {
    border-radius: 10px;
  }

  .view-product-sidebar {
    padding: 20px 14px;
  }

  .view-product-details {
    padding: 15px;
  }

  .view-product-actions {
    grid-template-columns: 1fr;
  }
}


/* ==============================
   Reduced Motion
   ============================== */

@media (prefers-reduced-motion: reduce) {
  .view-product-page *,
  .view-product-page *::before,
  .view-product-page *::after {
    transition: none !important;
    animation: none !important;
  }
}